import styled from 'styled-components';

export const Title = styled.h1`
  margin: 1em 0;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr; /* Due colonne: articoli + sidebar */
  gap: 1em;

  @media (min-width: 768px) {
    grid-template-columns: 2.2fr 0.8fr; /* Una colonna per dispositivi mobili */
  }
`;

export const LoadMoreGrid = styled.div`
  display: grid;
  justify-content: center; /* Centra il contenuto nella griglia */

  @media (max-width: 768px) {
    grid-template-columns: 1fr; /* Una colonna per dispositivi mobili */
  }
`;

export const ArticleList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.4em; /* Spaziatura tra gli articoli */

    @media (min-width: 768px) {
    gap: 2em;
  }
`;

export const ArticleCard = styled.div`
  display: flex;
  gap: 1em;
  padding-bottom: 2em;
  border-bottom: 1px solid #CC0000;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column; /* Layout verticale su mobile */
    gap: 1em;
    padding-bottom: 1em;
  }

  .image-container {
    flex: 1; /* Occupa il 50% */
    max-width: 50%; /* Limita la larghezza al 50% del contenitore */
    margin:0;

      @media (max-width: 768px) {
    max-width: 100%;
  }
  }

  .content-container {
    flex: 1; /* Occupa il 50% */
    display: flex;
    flex-direction: column;
    justify-content: space-between; /* Mantiene lo spazio tra gli elementi */
  }

  .category-title {
    margin: 0px 0 10px;
    color: #CC0000;
    font-size: 1rem;
  }

  .article-title {
    margin: 0;
    margin-bottom: 8px;
    font-size: 1.25rem;
    font-weight: bold;
  }

  .article-excerpt {
    margin: 0 0 10px;
    font-size: 1rem;
    color: #555;
  }
`;


export const Sidebar = styled.div`
  position: sticky;
  top: 20px;
  max-height: calc(100vh - 20px); /* Limita l'altezza massima */
  padding-left: 16px;
  overflow: hidden; /* Rimuove lo scroll */
  border-left: 1px solid #CC0000;
  justify-content: space-around;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    visibility: hidden; /* Nasconde la sidebar in mobile */
    display: none; /* Nasconde la sidebar in mobile */
  }
`;

export const LoadMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 2em 0 4em;
`;

export const LoadMoreButton = styled.button`
  padding: 16px 24px;
  border-radius: 4px;
  border: 2px solid #CC0000;
  background-color: white;
  cursor: pointer;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const ResponsiveImage = styled.img`
  width: 100%; /* Adatta l'immagine alla larghezza del contenitore */
  height: auto; /* Mantiene il rapporto d'aspetto */
  border-radius: 5px;
  display: block; /* Elimina lo spazio bianco sotto l'immagine */

  @media (max-width: 768px) {
    width: 100%; /* Full width in layout verticale */
  }

    @media (hover: hover) {
  &:hover {
    transform: scale(1.05);
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    }
  }
`;
